export enum Period {
  registrations,
  beforeEdition,
  duringEdition,
  afterEdition
}
